module.exports = __webpack_public_path__ + "static/img/guarantee.cc9b304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/guarantee.png
// module id = gvGq
// module chunks = 1